import { useLiveEvent } from "@/context/RealtimeContext";
import { Link } from "react-router-dom";
import { useLang } from "@/context/AppContext";
import { PageHead } from "@/pages/app/Dashboard";
import { StateBadge } from "@/components/StateBadge";
import { SocialBar } from "@/components/Social";
import { MessageCircle } from "lucide-react";
import { useApi } from "@/lib/useApi";

export default function Connections() {
  const { t } = useLang();
  const { data: items, setData: setItems, reload: load } = useApi("/relationships", { initial: [] });
  useLiveEvent(["notification"], (m) => ["state", "like", "message"].includes(m.data.type) && load());
  return (
    <div>
      <PageHead title={t("connections_title")} />
      {!items.length && <p className="text-sm text-slate-500" data-testid="connections-empty">{t("empty")}</p>}
      <div className="space-y-3">
        {items.map((r) => (
          <Link key={r.id} to={`/app/connections/${r.id}`} data-testid={`connection-row-${r.id}`}
            className="grid items-center gap-4 rounded-md border border-white/[0.08] bg-[#111827] p-5 transition-colors duration-200 hover:border-emerald-400/30 md:grid-cols-12">
            <div className="md:col-span-5">
              <p className="font-semibold text-white">{r.person.name} <span className="text-slate-500">↔</span> {r.company.name}</p>
              <p className="text-xs text-slate-400">{r.company_intent_title}</p>
            </div>
            <div className="md:col-span-1"><p className="font-display text-2xl font-bold text-emerald-300">{r.score}</p></div>
            <div className="md:col-span-3 flex items-center gap-3">
              <SocialBar compact r={r} onChange={(d) => setItems((all) => all.map((x) => (x.id === d.id ? { ...x, ...d } : x)))} />
              <span className="inline-flex items-center gap-1 font-mono text-[11px] text-slate-400" data-testid={`chat-count-${r.id}`}><MessageCircle className="h-4 w-4" />{r.unread_hint}</span>
            </div>
            <div className="md:col-span-3 md:text-right"><span className="mr-2 font-mono text-[11px] text-slate-500">{t("cycle")} {r.cycle}</span><StateBadge state={r.state} testId={`connection-state-${r.id}`} /></div>
          </Link>
        ))}
      </div>
    </div>
  );
}
